// removed by extract-text-webpack-plugin
module.exports = {"wrapper-layers__elements":"magazines_1yFGE","wrapper-layers__element":"magazines_2FgPO"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Editor/components/Layers/styles.scss
// module id = 1060
// module chunks = 1